import { render, staticRenderFns } from "./LinkedWorkItemsItem.vue?vue&type=template&id=9855c948&scoped=true&"
import script from "./LinkedWorkItemsItem.vue?vue&type=script&lang=js&"
export * from "./LinkedWorkItemsItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkedWorkItemsItem.vue?vue&type=style&index=0&id=9855c948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9855c948",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle,VTooltip})
